import React from 'react';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import EmailInput from '../../../common/components/EmailInput';
import Tooltip from '../../../common/components/Tooltip';
import ErrorMessage from '../../../common/components/ErrorMessage';
import MusicAlbumFirstPageNextButton from './MusicAlbumFirstPageNextButton';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumFirstPageRegistrationFormViewFieldName =
  'artist_registration_type'|'artist_registration_mbmail'|
  'artist_registration_password'|'artist_registration_agreement';

export default function MusicAlbumFirstPageRegistrationFormView({
  getValue,
  setValue,
  getErrors,
  onSubmit,
} : {
  getValue: (name: MusicAlbumFirstPageRegistrationFormViewFieldName) => string,
  setValue: (name: MusicAlbumFirstPageRegistrationFormViewFieldName, value: string) => void,
  getErrors: (name: MusicAlbumFirstPageRegistrationFormViewFieldName) => FieldValidationErrorsType,
  onSubmit: () => void,
}) {

  return (
    <form className="cake_ajax_form">
      <div className="form__body">
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label>Frekul IDをお持ちですか？</label>
            <Tooltip message="Frekulはあなたの音楽活動をサポートするWebサービスです。登録料/基本使用料は無料ですのでご安心ください。" />
          </dt>
          <dl>
            <input
              id="artist_registration_type-signup"
              type="radio"
              className="radio"
              name="artist_registration_type"
              value="signup"
              checked={getValue('artist_registration_type') === 'signup'}
              onChange={(e) => { setValue('artist_registration_type', 'signup'); }}
            />
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="artist_registration_type-signup">Frekul IDを持っていない（Frekul未登録）</label>
            <input
              id="artist_registration_type-auth"
              type="radio"
              className="radio"
              name="artist_registration_type"
              value="auth"
              checked={getValue('artist_registration_type') === 'auth'}
              onChange={(e) => { setValue('artist_registration_type', 'auth'); }}
            />
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="artist_registration_type-auth">Frekul IDを持っている（Frekul登録済み）</label>
          </dl>
          {(getValue('artist_registration_type') === 'signup' || getValue('artist_registration_type') === 'auth') && (
            <span>
              <dl className="register">
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <dt><label>メールアドレス</label></dt>
                <dd>
                  <EmailInput
                    value={getValue('artist_registration_mbmail')}
                    onChange={(value) => { setValue('artist_registration_mbmail', value); }}
                  />
                  <ErrorMessage type="error" validationErrors={getErrors('artist_registration_mbmail')} />
                </dd>
              </dl>
              <dl className="register">
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <dt><label>パスワード</label></dt>
                <dd>
                  <input
                    type="password"
                    value={getValue('artist_registration_password')}
                    onChange={(e) => { setValue('artist_registration_password', e.target.value); }}
                  />
                  <ErrorMessage type="error" validationErrors={getErrors('artist_registration_password')} />
                </dd>
              </dl>
            </span>
          )}
        </dl>
        {(getValue('artist_registration_type') === 'signup') && (
          <dl>
            <CustomCheckbox
              checked={getValue('artist_registration_agreement') !== '0'}
              setChecked={(checked) => setValue('artist_registration_agreement', checked ? '1' : '0')}
            >
              <a href="/terms" target="_blank">Frekul利用規約</a>
              に同意して登録する
            </CustomCheckbox>
            <ErrorMessage type="error" validationErrors={getErrors('artist_registration_agreement')} />
          </dl>
        )}
        <MusicAlbumFirstPageNextButton onClick={() => onSubmit()} />
      </div>
    </form>
  );
}
